import { render, staticRenderFns } from "./CampaignNotifications.vue?vue&type=template&id=4c0a34e2&scoped=true&"
import script from "./CampaignNotifications.vue?vue&type=script&lang=js&"
export * from "./CampaignNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0a34e2",
  null
  
)

export default component.exports